export enum CRMTypeEnum {
  Sales = 1,
  CarBuying
}
